<template>
  <div>
    <gtable-crud
      ref="gtable-crud"
      :data="data"
      :option="option"
      :page="page"
      :loading="loading"
      :before-close="beforeClose"
      @searchChange="searchChange"
      @searchReset="searchReset"
      @pageChange="pageChange"
      @pageSizeChange="pageSizeChange"
      @refresh-change="refreshChange"
      @submit-add="submitAdd"
      @submit-edit="submitEdit"
      @rowDel="rowDel"
    >
      <!-- 自定义列 -->
      <template slot="headMenuLeft">
        <my-tooltip :tooltip="i18n('attendanceScheme.position')">
          <!-- :disabled="downloading" -->
          <b-button
            variant="primary"
            class="btn ml-0-5 mr-0-5"
            size="sm"
            @click="openPositionPannel"
          >
            <feather-icon icon="MapPinIcon" size="18" />
          </b-button>
        </my-tooltip>
        <my-tooltip :tooltip="$t('_components.btns.add')">
          <!-- :disabled="downloading" -->
          <b-button
            variant="primary"
            class="btn ml-0-5 mr-0-5"
            size="sm"
            @click="openForm('add')"
          >
            <feather-icon icon="PlusIcon" size="18" />
          </b-button>
        </my-tooltip>
      </template>

      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field == 'projectIds'">
          <template v-if="props.row.projectIds">
            <b-badge
              v-for="(item, index) in props.row.projectNames.split(',')"
              :key="index"
              variant="light-primary"
              style="margin: 0.2rem"
              >{{ item }}</b-badge
            >
          </template>
        </span>
        <span v-else-if="props.column.field === 'status'">
          <template v-if="props.row.status === 0">
            <my-tooltip :tooltip="i18n('attendanceScheme.close')">
              <div class="status-tag bg-gradient-secondary" />
            </my-tooltip>
          </template>
          <template v-else>
            <my-tooltip :tooltip="i18n('attendanceScheme.start')">
              <div class="status-tag bg-gradient-success" />
            </my-tooltip>
          </template>
        </span>
      </template>
      <template slot="menuLeft" slot-scope="{ row }">
        <my-tooltip :tooltip="$t(`_components.btns.edit`)">
          <feather-icon
            style="margin-left: 1rem"
            icon="Edit2Icon"
            size="20"
            class="cursor-pointer text-warning"
            @click="openForm('edit', row)"
          />
        </my-tooltip>
      </template>
    </gtable-crud>
    <b-modal
      :header="true"
      :title="formKey"
      :dialog-class="dialogClass"
      size="lg"
      :footer="false"
      :visible="dialogShow"
      :modal-class="{
        'attendanceScheme-modal': true,
        'modal-footer-hide': true,
      }"
      @close="dialogClose"
    >
      <div style="width: 100%;height: 80vh;">
        <my-form
          ref="myForm"
          width="100%"
          :data="rowData"
          :loading="formLoading"
          :option="{ columns: addCol }"
          :page-key="formKey"
          @submit="handleSubmit($event, formKey)"
        />
      </div>
    </b-modal>
    <b-modal
      :title="i18n('attendanceScheme.position')"
      size="xl"
      :footer="false"
      :visible="positionShow"
      @close="positionClose()"
      :modal-class="{
        'modal-footer-hide': true,
      }"
    >
      <div style="width: 100%;height: 80vh;">
        <position-pannel @refresh="getAddressList" />
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  getList,
  add,
  update,
  remove,
} from '@/api/worker/attendance/attendanceScheme'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import Ripple from 'vue-ripple-directive'
import CMap from '@/components/map/index.vue'
import {
  BButton,
  BDropdownItem,
  BFormCheckbox,
  BCard,
  BCol,
  BRow,
  BForm,
  BFormGroup,
  BBadge,
  BModal,
} from 'bootstrap-vue'
import MyTooltip from '@/components/myTooltip.vue'
import CDrawer from '@/components/drawer.vue'
import CModal from '@/components/crud/modal.vue'
import ElementComponent from '@/components/elementComponent.vue'
import MyCard from '@/views/holiday/components/myCard.vue'
import { deepClone } from '@/util/util'
import positionPannel from './positionPannel.vue'
import Address from '@/api/base/address'
export default {
  components: {
    // CDrawer,
    MyForm: () => import('@/components/myForm/index.vue'),

    BModal,
    BBadge,
    MyTooltip,
    // BForm,
    BButton,
    // CModal,
    positionPannel,
  },
  data() {
    return {
      query: {},
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 12,
      },
      data: [],
      addressList: [],
      loading: false,
      dialogShow: false,
      formKey: 'add',
      rowData: {},
      positionShow: false,
    }
  },
  computed: {
    addCol() {
      let rowData = this.rowData
      console.log(this.rowData, 'rowData')
      const col = [
        {
          label: this.i18n('attendanceScheme.schemeName'),
          field: 'schemeName',
          search: true,
          searchBase: true,
          //   span: 4,
          formOption: {
            span: 4,
            rules: 'required',
          },
        },
        {
          label: this.i18n('attendanceScheme.workday'),
          field: 'workday',
          formOption: {
            span: 8,
            type: 'checkbox',
            rules: 'required',
            dictData: this.getWeekList(),
          },
        },
        {
          label: this.i18n('attendanceScheme.holidaySchemeId'),
          field: 'holidaySchemeId',
          formOption: {
            type: 'select',
            dictBizCode: 'workerSchemeList',
            // span: 4,
            rules: 'required',
            disabled: this.formKey === 'edit',
          },
        },
        {
          label: this.i18n('attendanceScheme.isAcross'),
          field: 'isAcross',
          formOption: {
            rules: 'required',
            type: 'radio',
            span: 4,
            // disabled: this.formKey === 'edit',
            dictData: [
              {
                label: this.i18n('attendanceScheme.spanDays'),
                value: 0,
              },
              {
                label: this.i18n('attendanceScheme.notSpanDays'),
                value: 1,
              },
            ],
          },
        },
        {
          label: this.i18n('attendanceScheme.newDayStartTime'),
          field: 'startTime',
          formOption: {
            type: 'time',
            span: 4,
            rules: 'required',
          },
        },
        {
          label: this.i18n('attendanceScheme.isIbeacon'),
          field: 'isIbeacon',
          formOption: {
            type: 'radio',
            span: 4,
            dictData: [
              {
                label: this.i18n('attendanceScheme.yes'),
                value: 1,
              },
              {
                label: this.i18n('attendanceScheme.no'),
                value: -1,
              },
            ],
          },
        },
        {
          label: this.i18n('attendanceScheme.status'),
          field: 'status',
          hide: true,
          formOption: {
            type: 'radio',
            span: 4,
            dictData: [
              {
                label: this.i18n('attendanceScheme.yes'),
                value: 1,
              },
              {
                label: this.i18n('attendanceScheme.no'),
                value: 0,
              },
            ],
          },
        },
        {
          label: this.i18n('attendanceScheme.clockInTime'),
          field: 'workTime',
          formOption: {
            type: 'time',
            span: 4,
            rules: 'required',
          },
        },
        {
          label: this.i18n('attendanceScheme.clockOutTime'),
          field: 'offTime',
          formOption: {
            type: 'time',
            span: 4,
            rules: 'required',
          },
        },
        {
          label: this.i18n('attendanceScheme.noonBreakHours'),
          field: 'noonBreakHours',
          formOption: {},
        },
        // {
        //   label: this.i18n('attendanceScheme.clockCardType'),
        //   field: 'clockCardType',
        //   formOption: {
        //     dictBizCode: 'clock_card_type',
        //     type: 'select',
        //     span: 4,
        //     rules: 'required',
        //   },
        // },
        {
          label: this.i18n('attendanceScheme.position'),
          field: 'addressIds',
          formOption: {
            type: 'check',
            dictCode: 'attendancePosition',
          },
        },
        {
          label: this.i18n('attendanceScheme.clockCardRadius'),
          field: 'clockCardRadius',
          formOption: {
            type: 'select',
            dictData: [
              {
                label: '50',
                value: 50,
              },
              {
                label: '100',
                value: 100,
              },
              {
                label: '150',
                value: 150,
              },
              {
                label: '200',
                value: 200,
              },
              {
                label: '250',
                value: 250,
              },
              {
                label: '300',
                value: 300,
              },
              {
                label: '400',
                value: 400,
              },
              {
                label: '500',
                value: 500,
              },
              {
                label: '600',
                value: 600,
              },
              {
                label: '700',
                value: 700,
              },
              {
                label: '800',
                value: 800,
              },
            ],
          },
        },
        // {
        //   label: this.i18n('attendanceScheme.clockCardName'),
        //   field: 'clockCardName',
        //   formOption: {
        //   },
        // },
        {
          label: this.i18n('attendanceScheme.schemeDesc'),
          field: 'schemeDesc',
          type: 'textarea',
          formOption: {
            type: 'textarea',
            span: 12,
          },
        },
        {
          label: this.i18n('attendanceScheme.workerIds'),
          field: 'workerIds',
          type: 'select',
          dictCode: 'worker',
          hide: true,
          span: 12,
          formOption: {
            type: 'select',
            dictCode: 'worker',
            multiple: true,
          },
        },
        {
          label: this.i18n('attendanceScheme.projectIds'),
          field: 'projectIds',
          type: 'check',
          dictName: 'projectName',
          span: 12,
          formOption: {
            type: 'check',
            hide:
              this.rowData.hasOwnProperty('isAcross') &&
              this.rowData.isAcross != 1,
            dictCode: 'project',
          },
        },
      ]
      return col
    },
    option() {
      const columns = [
        {
          label: this.i18n('attendanceScheme.schemeName'),
          field: 'schemeName',
          search: true,
          searchBase: true,
          span: 4,
          formOption: {
            rules: 'required',
            editHide: true,
          },
        },
        {
          label: this.i18n('attendanceScheme.workday'),
          field: 'workday',
          span: 8,
          hide: true,
          formOption: {
            rules: 'required',
            type: 'checkbox',
            dictData: this.getWeekList(),
            editHide: true,
          },
        },
        {
          label: this.i18n('attendanceScheme.holidaySchemeId'),
          field: 'holidaySchemeId',
          type: 'select',
          dictBizCode: 'workerSchemeList',
          dictField: 'holidaySchemeName',
          hide: true,
          formOption: {
            type: 'select',
            dictBizCode: 'workerSchemeList',
            rules: 'required',
          },
        },
        {
          label: this.i18n('attendanceScheme.newDayStartTime'),
          field: 'startTime',
          type: 'time',
          formOption: {
            rules: 'required',
            editHide: true,
          },
        },
        {
          label: this.i18n('attendanceScheme.clockInTime'),
          field: 'workTime',
          type: 'time',
          formOption: {
            rules: 'required',
            editHide: true,
          },
        },
        {
          label: this.i18n('attendanceScheme.clockOutTime'),
          field: 'offTime',
          type: 'time',
          formOption: {
            rules: 'required',
            editHide: true,
          },
        },
        {
          label: this.i18n('attendanceScheme.isAcross'),
          field: 'isAcrossName',
        },
        {
          label: this.i18n('attendanceScheme.noonBreakHours'),
          field: 'noonBreakHours',
          hide: true,
        },
        // {
        //   label: this.i18n('attendanceScheme.status'),
        //   field: 'status',
        //   hide: true,
        // },
        // {
        //   label: this.i18n('attendanceScheme.clockCardType'),
        //   field: 'clockCardType',
        //   type: 'select',
        //   dictBizCode: 'clock_card_type',
        //   dictField: 'clockCardTypeName',
        //   formOption: {
        //     type: 'select',
        //     dictBizCode: 'clock_card_type',
        //     rules: 'required',
        //     editHide: true,
        //   },
        // },
        // {
        //   label: this.i18n('attendanceScheme.clockCardIp'),
        //   field: 'clockCardIp',
        //   formOption: {
        //     editHide: true,
        //   },
        // },
        // {
        //   label: this.i18n('attendanceScheme.position'),
        //   field: 'position',
        //   // type: 'map',
        //   type: 'input',
        //   formOption: {
        //     editHide: true,
        //   },
        // },
        {
          label: this.i18n('attendanceScheme.clockCardRadius'),
          field: 'clockCardRadius',
          type: 'select',
          dictData: [
            {
              label: '50',
              value: 50,
            },
            {
              label: '100',
              value: 100,
            },
            {
              label: '150',
              value: 150,
            },
            {
              label: '200',
              value: 200,
            },
            {
              label: '250',
              value: 250,
            },
            {
              label: '300',
              value: 300,
            },
            {
              label: '400',
              value: 400,
            },
          ],
          formOption: {
            editHide: true,
            type: 'select',
            dictData: [
              {
                label: '50',
                value: 50,
              },
              {
                label: '100',
                value: 100,
              },
              {
                label: '150',
                value: 150,
              },
              {
                label: '200',
                value: 200,
              },
              {
                label: '250',
                value: 250,
              },
              {
                label: '300',
                value: 300,
              },
              {
                label: '400',
                value: 400,
              },
              {
                label: '400',
                value: 400,
              },
              {
                label: '500',
                value: 500,
              },
              {
                label: '600',
                value: 600,
              },
              {
                label: '700',
                value: 700,
              },
              {
                label: '800',
                value: 800,
              },
            ],
          },
        },
        // {
        //   label: this.i18n('attendanceScheme.clockCardName'),
        //   field: 'clockCardName',
        //   formOption: {
        //     editHide: true,
        //   },
        // },
        // {
        //   label: this.i18n('attendanceScheme.schemeDesc'),
        //   field: 'schemeDesc',
        //   type: 'textarea',
        //   span: 12,
        //   formOption: {
        //     editHide: true,
        //   },
        // },
        // {
        //   label: this.i18n('attendanceScheme.workerIds'),
        //   field: 'workerIds',
        //   type: 'select',
        //   dictCode: 'worker',
        //   hide: true,
        //   span: 12,
        //   formOption: {
        //     type: 'select',
        //     dictCode: 'worker',
        //     multiple: true,
        //   },
        // },
        {
          label: this.i18n('attendanceScheme.projectIds'),
          field: 'projectIds',
          type: 'check',
          dictCode: 'project',
          dictName: 'projectName',
          span: 12,
          formOption: {
            type: 'check',
            dictCode: 'project',
            editHide: true,
          },
        },
        {
          label: this.i18n('attendanceScheme.status'),
          field: 'status',
          span: 12,
          formOption: {
            viewHide: true,
            editHide: true,
            addHide: true,
          },
        },
      ]
      const option = {
        header: true, // 显示顶部功能区(默认 true)
        isEnterSearch: true,

        addBtn: false, // 新增按钮(默认 true)
        viewBtn: true, // 显示按钮(默认 true)
        editBtn: false, // 修改按钮(默认 true)
        delBtn: true, // 删除按钮(默认 true)

        search: true, // 显示搜索(默认 true)
        menu: true, // 显示菜单(默认 true)
        menuWidth: 200, // 默认200
        form: true, // 是否使用自带form (默认true)
        // drawerWidth: 500, // 默认auto
        searchVisible: false, // 搜索默认展开(默认 false)
        fixedHeader: false, // 固定表头(默认 true)
        lineNumbers: false, // 显示每行数据的下标(默认 false)
        searchSpan: 4, // 自定义搜索栅格(默认 4)

        columns,
      }
      return option
    },
    // formatData() {
    //   let formData = deepClone(this.data)
    //   formData = formData.map(el => {
    //     const obj = deepClone(el)
    //     obj.workday = obj.workday.split(',')
    //     return obj
    //   })
    //   return formData
    // },
  },
  mounted() {
    this.onLoad(this.page)
    this.getAddressList()
  },
  watch: {
    'rowData.isAcross': function(val) {
      console.log(val, 'val')
      if (val == 0) {
        this.rowData.projectIds = ''
        this.rowData.projectNames = ''
      }
    },
  },
  methods: {
    async onLoad(page, params = {}) {
      this.loading = true
      const res = await getList(
        page.currentPage,
        page.pageSize,
        Object.assign(params, this.query),
      )
      const { data } = res.data
      data.records.forEach((item) => {
        item.isAcrossName =
          item.isAcross == 1
            ? this.i18n('attendanceScheme.notSpanDays')
            : this.i18n('attendanceScheme.spanDays')
      })
      this.page.total = data.total
      this.data = data.records
      this.loading = false
    },
    getAddressList() {
      Address.getList(1, -1).then((res) => {
        this.addressList = res.data.data.records || []
      })
    },
    positionClose() {
      this.positionShow = false
      this.getAddressList()
    },
    openForm(formKey, row) {
      this.dialogShow = true
      this.formKey = formKey
      console.log(formKey, 'formKey')
      const obj = deepClone(row)
      if (formKey === 'add') {
        console.log(formKey, 'formKey')
        this.rowData = {}
        // obj.noonBreakHours = 1
        this.rowData.noonBreakHours = 1
        // this.rowData.isAcross = 1
      } else {
        this.rowData = obj
      }
    },
    dialogClose() {
      this.dialogShow = false
    },
    openPositionPannel() {
      this.positionShow = true
    },
    handleSubmit(row, formKey) {
      if (formKey === 'edit') {
        const form = deepClone(row)
        const addressIdList = form.addressIds ? form.addressIds.split(',') : ''
        console.log(this.addressList)
        form.clockCardLat = this.addressList
          .filter(
            (item) =>
              addressIdList.includes(item.id) &&
              item.addressLat &&
              item.addressLon,
          )
          .map((e) => e.addressLat)
          .join(',')
        form.clockCardLon = this.addressList
          .filter(
            (item) =>
              addressIdList.includes(item.id) &&
              item.addressLat &&
              item.addressLon,
          )
          .map((e) => e.addressLon)
          .join(',')
        form.attendanceAddressList = this.addressList.filter((item) =>
          addressIdList.includes(item.id),
        )
        console.log(form)
        // form.workday = form.workday.join(',')
        update(form).then((res) => {
          this.dialogShow = false
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('_default.toast.title'),
              icon: 'BellIcon',
              text: this.$t('_default.toast.text.success'),
              variant: 'success',
            },
          })
          this.onLoad(this.page)
        })
      }
      if (formKey === 'add') {
        const form = deepClone(row)
        const addressIdList = form.addressIds ? form.addressIds.split(',') : ''
        form.clockCardLat = this.addressList
          .filter(
            (item) =>
              addressIdList.includes(item.id) &&
              item.addressLat &&
              item.addressLon,
          )
          .map((e) => e.addressLat)
          .join(',')
        form.clockCardLon = this.addressList
          .filter(
            (item) =>
              addressIdList.includes(item.id) &&
              item.addressLat &&
              item.addressLon,
          )
          .map((e) => e.addressLon)
          .join(',')
        form.attendanceAddressList = this.addressList.filter((item) =>
          addressIdList.includes(item.id),
        )
        // form.workday = form.workday.join(',')
        form.clockCardType = 1
        const paramsList = ['holidaySchemeId']
        Object.entries(row).forEach(([key, value]) => {
          if (paramsList.includes(key) && (value === '' || !value)) {
            delete form[key]
          }
        })
        add(form).then((res) => {
          this.dialogShow = false
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('_default.toast.title'),
              icon: 'BellIcon',
              text: this.$t('_default.toast.text.success'),
              variant: 'success',
            },
          })
          this.onLoad(this.page)
        })
      }
    },
    update(row) {
      const obj = {}
      update(obj).then((res) => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('_default.toast.title'),
            icon: 'BellIcon',
            text: this.$t('_default.toast.text.success'),
            variant: 'success',
          },
        })
        this.onLoad(this.page)
      })
    },
    rowDel(row) {
      const ids = row.id
      remove(ids).then((res) => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('_default.toast.title'),
            icon: 'BellIcon',
            text: this.$t('_default.toast.text.success'),
            variant: 'success',
          },
        })
        this.onLoad(this.page)
      })
    },
    // i18n
    i18n(param) {
      return this.$t(`_worker.${param}`)
    },
    // 搜索按钮被点击
    async searchChange(done, e) {
      this.query = e
      this.page.currentPage = 1
      await this.onLoad(this.page, e)
      done()
    },
    // 搜索重置
    searchReset() {
      this.query = {}
      this.onLoad(this.page)
    },
    refreshChange() {
      this.onLoad(this.page, this.query)
    },
    // 当前页改变
    pageChange(e) {
      this.page.currentPage = e
      this.onLoad(this.page)
    },
    // 页数据数量改变
    pageSizeChange(e) {
      this.page.pageSize = e
      this.onLoad(this.page)
    },
    beforeClose(done) {
      this.onLoad(this.page)
      done()
    },
    getWeekList() {
      const { locale } = this.$i18n
      const weekListEn = [
        { label: 'Mon', value: '1' },
        { label: 'Tues', value: '2' },
        { label: 'Wed', value: '3' },
        { label: 'Thur', value: '4' },
        { label: 'Fri', value: '5' },
        { label: 'Sat', value: '6' },
        { label: 'Sun', value: '7' },
      ]
      const weekListZh = [
        { label: '星期一', value: '1' },
        { label: '星期二', value: '2' },
        { label: '星期三', value: '3' },
        { label: '星期四', value: '4' },
        { label: '星期五', value: '5' },
        { label: '星期六', value: '6' },
        { label: '星期日', value: '7' },
      ]
      let weekList = []
      weekList = locale === 'zh' ? weekListZh : weekListEn
      return weekList
    },
  },
}
</script>

<style lang="scss">
.dialogClass {
  z-index: 999;
}

.attendanceScheme-modal {
  .modal-dialog {
    min-width: 1000px;
    max-width: 1400px;
    margin-top: 80px;
  }
}
</style>
